/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';

import { RebrandShell } from 'components/rebrand/RebrandShell';
import { AuthContext } from 'context/AuthContext';
import { getFaq } from 'services/content.service';

import FaqItem from './FaqItem';
import './styles.scss';

export default function Faq() {
  const [faqList, setFaqList] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [activeItem, setActiveItem] = useState('');
  const [optionsCycle, setOptionsCycle] = useState<any[]>([]);

  const { realCycle, user } = useContext(AuthContext);

  useEffect(() => {
    async function loadData() {
      if (!activeItem || !user?.extra) return;
      setLoading(true);
      const data = await getFaq(activeItem, user?.extra?.rede);
      if (data) setFaqList(data);
      setLoading(false);
    }
    loadData();
  }, [activeItem, user]);

  useEffect(() => {
    if (!realCycle || !user?.extra) return;

    const cycleOptions = realCycle
      .filter(
        (item: any) =>
          (user?.extra?.rede && item?.date_start >= 1706886000000) || (!user?.extra?.rede && item?.date_start >= 1690772400000),
      )
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;
        return cycle;
      });

    setOptionsCycle(cycleOptions);
    if (cycleOptions.length && !activeItem) {
      setActiveItem(cycleOptions[0].value);
    }
  }, [realCycle, user]);

  return (
    <RebrandShell
      title="Ajuda"
      subtitle="Encontre respostas para as principais dúvidas sobre o Reconheça BRB."
    >
      <div className="rb-faq-toolbar">
        <h2 className="rb-faq-toolbar__label">Perguntas Frequentes</h2>
        {optionsCycle.length > 0 && (
          <select
            className="rb-input rb-faq-toolbar__select"
            value={activeItem}
            onChange={e => setActiveItem(e.target.value)}
            aria-label="Selecionar ciclo"
          >
            {optionsCycle.map((cycle: any) => (
              <option key={cycle.value} value={cycle.value}>
                {cycle.label}
              </option>
            ))}
          </select>
        )}
      </div>

      <div className="rb-faq-list">
        {loading && (
          <>
            <div className="rb-skeleton" style={{ height: 64 }} />
            <div className="rb-skeleton" style={{ height: 64 }} />
            <div className="rb-skeleton" style={{ height: 64 }} />
          </>
        )}

        {!loading && !!faqList && faqList.map((item: any) => <FaqItem key={item._id} _id={item._id} title={item.title} />)}

        {!loading && (!faqList || faqList.length === 0) && <div className="rb-empty">Nenhuma pergunta disponível para este ciclo.</div>}
      </div>
    </RebrandShell>
  );
}
